import React from 'react';
export function SolutionSection() {
  return <section className="w-full bg-black py-16 px-4" data-id="element-324">
      <div className="max-w-4xl mx-auto text-center" data-id="element-325">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 border border-[#00B4D8]/50 text-[#00B4D8] font-bold text-sm px-5 py-2 rounded-full mb-8 tracking-wide" data-id="element-326">
          🏆 Sistema N°1 para Profesores de Tenis en Argentina
        </div>

        <h2 className="text-4xl sm:text-5xl font-black text-white mb-4" data-id="element-327">
          🎾 PROFEPACK™
        </h2>
        <h3 className="text-2xl sm:text-3xl font-bold text-[#00B4D8] mb-6" data-id="element-328">
          MEGAPACK TENIS LISTO
        </h3>
        <p className="text-white text-lg max-w-2xl mx-auto mb-10 leading-relaxed" data-id="element-329">
          <strong data-id="element-330">
            6 Tomos + 6 Bonos — Todos los niveles — Todo resuelto.
          </strong>
          <br data-id="element-331" />
          +540 páginas · 48 semanas modelo · 52 calentamientos · Técnica ·
          Táctica · Drills · Planificación · Evaluación · Gestión · Negocio.
          Funciona desde hoy.
        </p>

        {/* Mockup visual */}
        <div className="relative mx-auto mb-10 max-w-2xl" data-id="element-332">
          <div className="grid grid-cols-6 gap-2 justify-center" data-id="element-333">
            {['#1565C0', '#2E7D32', '#E65100', '#6A1B9A', '#37474F', '#BF360C'].map((color, i) => {
            const labels = ['Sub-10', 'Junior', 'Adultos', 'Avanzado', 'Táctica', 'Físico'];
            return <div key={i} className="aspect-[3/4] rounded-lg shadow-2xl flex items-end justify-center pb-2" style={{
              backgroundColor: color,
              border: '2px solid #00B4D8'
            }} data-id="element-334">
                  <span className="text-white text-xs font-bold" style={{
                textShadow: '0 1px 3px rgba(0,0,0,0.8)'
              }} data-id="element-335">
                    {labels[i]}
                  </span>
                </div>;
          })}
          </div>
          <div className="absolute -bottom-3 left-1/2 -translate-x-1/2 bg-[#00B4D8] text-black font-black text-xs px-4 py-1 rounded-full whitespace-nowrap" data-id="element-336">
            6 TOMOS COMPLETOS
          </div>
        </div>

        {/* Pills */}
        <div className="flex flex-wrap items-center justify-center gap-3 mt-8" data-id="element-337">
          <span className="bg-[#00B4D8]/10 border border-[#00B4D8]/40 text-[#00B4D8] text-sm font-semibold px-4 py-2 rounded-full" data-id="element-338">
            ✅ Por nivel y categoría argentina
          </span>
          <span className="bg-[#00B4D8]/10 border border-[#00B4D8]/40 text-[#00B4D8] text-sm font-semibold px-4 py-2 rounded-full" data-id="element-339">
            ✅ 48 semanas de clases completas con objetivo y cierre
          </span>
          <span className="bg-[#00B4D8]/10 border border-[#00B4D8]/40 text-[#00B4D8] text-sm font-semibold px-4 py-2 rounded-full" data-id="element-340">
            ✅ Evaluación + fichas de progreso por nivel
          </span>
          <span className="bg-[#00B4D8]/10 border border-[#00B4D8]/40 text-[#00B4D8] text-sm font-semibold px-4 py-2 rounded-full" data-id="element-341">
            ✅ Drills + Canastos + Planificación + Negocio
          </span>
        </div>
      </div>
    </section>;
}